module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-view"
  }, [_c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "login-form-view"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "autoComplete": "on",
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title-view"
  }, [_vm._v("视频管理系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "userName"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('i', {
    staticClass: "user-name-icon"
  })]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "userName",
      "type": "text",
      "autoComplete": "on",
      "placeholder": "用户名",
      "trigger-on-focus": "false"
    },
    on: {
      "blur": function($event) {
        return _vm.handleUserNameBlur()
      }
    },
    model: {
      value: (_vm.loginForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "userName", $$v)
      },
      expression: "loginForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('i', {
    staticClass: "password-icon"
  })]), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "autoComplete": "on",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), (_vm.showVerifyCode) ? _c('el-form-item', {
    attrs: {
      "prop": "verifyCode"
    }
  }, [_c('span', {
    staticClass: "svg-container"
  }, [_c('i', {
    staticClass: "verifycode-icon"
  })]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "name": "identifyCode",
      "type": "text",
      "maxlength": "4",
      "placeholder": "验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.verifyCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "verifyCode", $$v)
      },
      expression: "loginForm.verifyCode"
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "returnCode",
    attrs: {
      "src": _vm.photoCode,
      "fit": "contain",
      "loading": _vm.codeLoading
    },
    on: {
      "click": _vm.clickReload
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          登 录\n        ")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "other-handle-view"
  }, [_c('div', {
    staticClass: "button-view"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "color": "#fff"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleRegister
    }
  }, [_vm._v("还没有账号?立即注册")])], 1)]) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1874c10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1874c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/LoginPage.vue
// module id = 1317
// module chunks = 1